import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { adminSubpilar, getSubpilares } from "Services/subPilares_service";
import { setResponse } from "Slices/Response/responseSlice";
import { setToast, setLoading, setModal } from "Slices/uiSlice";


const initialState = {
    subpilares: [],
    subpilar: {
        nombre: '',
        estado: 1,
        idCategoria: null,
        descripcion: '',
    },
}

export const subPilarSlice = createSlice({
    name: 'subpilar',
    initialState,
    reducers: {
        setSubPilares: (state, action) => {
            state.subpilares = action.payload;
        },
        setSubPilar: (state, action) => {
            state.subpilar = action.payload ?? initialState.subpilar;
        },
        updateSubpilarField: (state, action) => {
            const { name, value } = action.payload;
            state.subpilar[name] = value;
        },
    }
});

export const fetchSubpilares = createAsyncThunk(
    'subpilar/fetchSubpilares',
    async (_, { dispatch }) => {
        const subpilarRes = await getSubpilares();
        dispatch(setSubPilares(subpilarRes));
    }
);

export const mergeSubpilar = createAsyncThunk(
    'subpilar/merge',
    async (data, {dispatch}) => {
        dispatch(setLoading(true))
        const subpilarRes = await adminSubpilar(data);
        dispatch(setResponse(subpilarRes));
        dispatch(setLoading(false));
        dispatch(setModal(false));
        dispatch(setToast(true));
        dispatch(fetchSubpilares());
        setTimeout(() => {
            dispatch(setToast(false));
        }, 3000);
    }
);

export const { setSubPilares, setSubPilar, updateSubpilarField } = subPilarSlice.actions;
export default subPilarSlice.reducer;